import { p as parsePlayerError } from './errors-51b2e81a.js';

function getAdapterOptions(platform) {
  return {
    errorParser: function errorParser(error) {
      return _errorParser(platform, parsePlayerError(error));
    }
  };
}
function _errorParser(platform, parsedError) {
  var _parsedError$data, _parsedError$data2, _parsedError$data3, _parsedError$data3$re, _parsedError$data4, _parsedError$data4$re, _parsedError$data5;
  if (!(parsedError !== null && parsedError !== void 0 && parsedError.group) || !(parsedError !== null && parsedError !== void 0 && parsedError.category)) return undefined;
  var context = "".concat(parsedError.group, ": ").concat(parsedError.category);
  return {
    name: context,
    description: "[".concat(platform, "][").concat(context, "] - ").concat(getDescriptionComplement(parsedError)),
    metadata: {
      internalCode: (_parsedError$data = parsedError.data) === null || _parsedError$data === void 0 ? void 0 : _parsedError$data.internalCode,
      requestURL: (_parsedError$data2 = parsedError.data) === null || _parsedError$data2 === void 0 ? void 0 : _parsedError$data2.requestURL,
      responseStatusCode: (_parsedError$data3 = parsedError.data) === null || _parsedError$data3 === void 0 ? void 0 : (_parsedError$data3$re = _parsedError$data3.response) === null || _parsedError$data3$re === void 0 ? void 0 : _parsedError$data3$re.status,
      responsePayload: (_parsedError$data4 = parsedError.data) === null || _parsedError$data4 === void 0 ? void 0 : (_parsedError$data4$re = _parsedError$data4.response) === null || _parsedError$data4$re === void 0 ? void 0 : _parsedError$data4$re.data,
      detail: (_parsedError$data5 = parsedError.data) === null || _parsedError$data5 === void 0 ? void 0 : _parsedError$data5.originalError
    }
  };
}
function getDescriptionComplement(parsedError) {
  var _parsedError$data6, _parsedError$data6$re, _parsedError$data7, _parsedError$data7$or, _parsedError$data7$or2, _parsedError$data8;
  if ((_parsedError$data6 = parsedError.data) !== null && _parsedError$data6 !== void 0 && (_parsedError$data6$re = _parsedError$data6.response) !== null && _parsedError$data6$re !== void 0 && _parsedError$data6$re.status) {
    if (!parsedError.data.response.message) return "statusCode: ".concat(parsedError.data.response.status);
    return "statusCode: ".concat(parsedError.data.response.status, " - ").concat(parsedError.data.response.message);
  }
  if (parsedError.message) return "message: ".concat(parsedError.message);
  return "stack: ".concat(((_parsedError$data7 = parsedError.data) === null || _parsedError$data7 === void 0 ? void 0 : (_parsedError$data7$or = _parsedError$data7.originalError) === null || _parsedError$data7$or === void 0 ? void 0 : (_parsedError$data7$or2 = _parsedError$data7$or.toString) === null || _parsedError$data7$or2 === void 0 ? void 0 : _parsedError$data7$or2.call(_parsedError$data7$or)) || ((_parsedError$data8 = parsedError.data) === null || _parsedError$data8 === void 0 ? void 0 : _parsedError$data8.internalCode));
}

var npaw = /*#__PURE__*/Object.freeze({
  __proto__: null,
  errorParser: _errorParser,
  getAdapterOptions: getAdapterOptions
});

export { _errorParser as _, getAdapterOptions as g, npaw as n };
//# sourceMappingURL=npaw-49e88839.js.map
